import { useState, useEffect, useRef } from "react";

export default function TagMultiSelect({ options, selected, setSelected, helper }: { options: any, selected: any, setSelected: (selected: any) => void, helper: string }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const toggleSelect = (value) => {
        if (selected.includes(value)) {
            setSelected(selected.filter((v) => v !== value));
        } else {
            setSelected([...selected, value]);
        }
    };

    return (
        <div className="relative" ref={dropdownRef}>
            {/* Input box */}
            <div
                className="min-h-10 flex items-center flex-wrap gap-1 rounded-xl border border-slate-200 bg-slate-50 px-2 py-1 cursor-pointer"
                onClick={() => setOpen(!open)}
            >
                {selected.length === 0 && (
                    <span className="text-xs text-slate-400">{helper}</span>
                )}

                {selected.map((uid: string) => {
                    const person = options.find((m) => helper === 'Select skills...' ? m.skill_Id === uid : m.uid === uid);
                    return (
                        <span
                            key={uid}
                            className="flex items-center gap-1 bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full text-xs"
                        >
                            {person?.name}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSelect(uid);
                                }}
                                className="text-[10px] text-emerald-700 hover:text-emerald-900"
                            >
                                ✕
                            </button>
                        </span>
                    );
                })}
            </div>

            {/* Dropdown */}
            {open && (
                <div className="absolute z-10 mt-1 w-full rounded-xl border border-slate-200 bg-white shadow-md max-h-52 overflow-auto">
                    {options.map((item: any) => {
                        const active = selected.includes(helper === 'Select skills...' ? item.skill_Id : item.uid);
                        return (
                            <div
                                key={helper === 'Select skills...' ? item.skill_Id : item.uid}
                                className={`px-3 py-2 text-sm cursor-pointer flex items-center justify-between hover:bg-slate-100
                                    ${active ? "bg-slate-100 font-semibold" : ""}
                                `}
                                onClick={() => toggleSelect(helper === 'Select skills...' ? item.skill_Id : item.uid)}
                            >
                                <span>{item.name}</span>
                                {active && <span className="text-emerald-600 text-xs">✓</span>}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}